import { Store, Module, ActionContext } from 'vuex'
import ListModule from './list-module'
import ListState from './list-state'
import ProductFileLine from '../entities/product-file-line'
import Ajax from '../../lib/ajax'
import PageResult from '@/store/entities/page-result';
import appconst from './../../lib/appconst';
import _ from 'lodash';

interface ProductImportState extends ListState<ProductFileLine> {
    itemsImported : Array<ProductFileLine>, 
    countItems : number,
    countImportedItems: number
}
class ProductImportModule extends ListModule<ProductImportState, any, ProductFileLine>{
    state = {
        totalCount: 0,
        currentPage: 1,
        pageSize: 10,
        itemsImported : new Array<ProductFileLine>(), 
        list: new Array<ProductFileLine>(),
        loading: false,
        countItems:0,
        countImportedItems:0
    }
    actions = {
        async getAll(context: ActionContext<ProductImportState, any>, payload: any) {
            context.state.loading = true;
            let reponse = await Ajax.get('/api/services/app/ProductFile/GetAll', { params: payload.data });
            context.state.loading = false;
            let page = reponse.data.result as PageResult<ProductFileLine>;
            context.state.totalCount = page.totalCount;
            context.state.list = page.items;
        },
        async uploadImportProductFile(context: ActionContext<ProductImportState, any>, data: any) {
            let reponse = await Ajax.post('/api/services/app/ProductFile/ImportProduct', data);
            return reponse.data.result;
        },
        async export(context:ActionContext<ProductImportState,any>,payload:any){
            window.open(`${appconst.remoteServiceBaseUrl}import/exportImportProducts/`+payload.data, "_blank");    
        }
    };
    mutations = {
        setCurrentPage(state: ProductImportState, page: number) {
            state.currentPage = page;
        },
        setPageSize(state: ProductImportState, pagesize: number) {
            state.pageSize = pagesize;
        },
        setCountItems(state: ProductImportState, count: number) {
            state.countItems = count;
        },
        setCountImportedItems(state: ProductImportState, count: number) {
            state.countImportedItems = count;
        },
        processNotifier(state: ProductImportState, payload: any) {
            if (payload.data != null) {
                if (payload.data.data != undefined && payload.data.data != null) {
                    let productLines = payload.data.data as Array<ProductFileLine>;
                    var itemsImported = _.clone(state.itemsImported);
                    itemsImported= productLines.concat(itemsImported);
                    state.itemsImported = Object.freeze(itemsImported);
                }
                if (payload.data.countItems != undefined && payload.data.countItems != null) {
                    state.countItems = payload.data.countItems as number;
                }
                if (payload.data.countImportedItems != undefined && payload.data.countImportedItems != null) {
                    state.countImportedItems = payload.data.countImportedItems as number;
                }
            }
        },
        resetList(state: ProductImportState) {
            state.itemsImported = new Array<ProductFileLine>();
        },
    }
}
const productImportModule = new ProductImportModule();
export default productImportModule;